<template>
  <div class="row justify-content-between">
    <Button :title="this.sort==='sort'?'<i class=\'fas fa-sort-numeric-up-alt\'></i>':'<i class=\'fas fa-sort-numeric-up\'></i>'" class-name="btn-info mb-1" :onclick="()=>this.sort = this.sort==='sort'?'asort':'sort'"/>
    <Button title="Yeni Anlatım Ekle" class-name="btn-dark mb-1" :onclick="()=>ekleModal()"/>
  </div>
  <div class="row">

   <TableContainer :titles="['Sıra','Başlık','İçerik','İşlemler']">
        <tr v-for="data in showedData" :key="data.firebaseKey">
          <td>{{data.kacinci}}</td>
          <td class="text-light">{{data.baslik}}</td>
          <td class="text-light">{{data.icerik}} <a :href="`https://kpss-genel-app.web.app/anlatim/${findUrl}/${data.icerik}.html`"  class="text-info" target="_blank">İçeriği Gör</a></td>
          <td>
            <Button title="Düzenle" class-name="btn-outline-info" :onclick="()=>duzenleModal(data.firebaseKey)"/>
            <Button title="Sil" class-name="btn-outline-danger ml-1 mt-1" :onclick="()=>deleteDataConfirm(data.firebaseKey)"/>
          </td>
        </tr>
   </TableContainer>
    <DeleteAlert :show="dataWillDelete.show" :onOkey="()=>deleteData(this.gecerliId)" v-on:show-box-changed="handleShowBoxChanged" :title="dataWillDelete.baslik"/>
    <Pagination :page="page" :item-count="itemCount" v-if="pageShow"/>
  </div>
  <Modal :className="modalShow" title="Detaylı Anlatım Ekle / Düzenle" @on-closed="handleClose">

      <TextInput title="Başlık" name="baslik" placeholder="Başlık Girin" :model="baslik" v-on:datachanged="dataChanged"/>
      <TextInput title="Sırası" name="kacinci" placeholder="Sıralama" type="number" :model="kacinci" v-on:datachanged="dataChanged"/>
      <TextInput title="Link" name="icerik" placeholder="İçerik Girin" :model="icerik" v-on:datachanged="dataChanged"/>

    <Button title="Kaydet" class-name="btn-success" :onclick="()=>updateData()"/>
  </Modal>
</template>
<script>

import Modal from '@/components/App/Modal'
import Pagination from '@/components/App/Pagination'
import TableContainer from '@/views/containers/TableContainer'
import Button from '@/components/forms/Button'
import TextInput from '@/components/forms/TextInput'
import DeleteAlert from '@/components/App/DeleteAlert'
import {
  findCurrentData,
  findNewKacinci,
  findPage,
  findSortedData,
  get,
  insert,
  remove,
  update
} from '@/crud'
export default {
  name: 'MiniOzet',
  components: {
    DeleteAlert,
    TextInput,
    Button,
    TableContainer,
    Pagination,
    Modal
  },
  props: ['search'],
  data () {
    return {
      modalShow: 'hide',
      contents: [],
      itemCount: 0,
      page: 1,
      pageShow: true,
      showedData: [],
      baslik: '',
      icerik: '',
      kacinci: '',
      gecerliId: false,
      sort: 'sort',
      dataWillDelete: { show: false, baslik: '' },
      tableName: 'detaylianlatim/' + this.$route.params.id,
      slugs: [
        { slug: 'matematik', id: '-MFk8fh4baA4eTMJ_eKi' },
        { slug: 'turkce', id: '-MFk8fCIKqjXMeg_wL_Q' },
        { slug: 'cografya', id: '-MFk8f_DEY3ygjv1pDlD' },
        { slug: 'anayasa', id: '-MFk8fKKUpz8FMHDsHbZ' },
        { slug: 'tarih', id: '-MFk8fTULnQ4r88TbQAh' }
      ]
    }
  },
  methods: {
    handleShowBoxChanged () {
      this.dataWillDelete = { show: false, baslik: '' }
      this.gecerliId = false
    },
    workContent () {
      this.page = findPage(this.$route)
      this.contents = findSortedData(this.sort, this.contents)
      this.showedData = this.content
    },
    duzenleModal (data) {
      const current = findCurrentData(this.contents, data)
      this.baslik = current.baslik
      this.icerik = current.icerik
      this.kacinci = current.kacinci
      this.gecerliId = data
      this.modalShow = 'show'
    },
    ekleModal () {
      this.baslik = ''
      this.icerik = ''
      this.kacinci = findNewKacinci(this.contents, 'kacinci')
      this.gecerliId = false
      this.modalShow = 'show'
    },
    deleteData () {
      remove(this.tableName + '/' + this.gecerliId, this.handleShowBoxChanged)
    },
    deleteDataConfirm (data) {
      const current = findCurrentData(this.contents, data)
      this.gecerliId = data
      this.dataWillDelete = { show: true, baslik: current.baslik }
    },
    updateData () {
      if (this.gecerliId) {
        const current = findCurrentData(this.contents, this.gecerliId)
        delete current.firebaseKey
        update(this.tableName + '/' + this.gecerliId, {
          baslik: this.baslik,
          icerik: this.icerik,
          kacinci: this.kacinci
        }, () => {
          this.modalShow = 'hide'
        })
      } else {
        insert(this.tableName, {
          baslik: this.baslik,
          icerik: this.icerik,
          kacinci: this.kacinci
        }, () => {
          this.modalShow = 'hide'
        })
      }
    },
    handleClose (data) {
      this.modalShow = data
    },
    dataChanged (data, name) {
      this[name] = data
    },
    getData () {
      this.$store.dispatch('setLoading', true)
      get({
        child: this.tableName,
        callback: snapshot => {
          this.contents = this.makeArray(snapshot.val())
          this.workContent()
          this.itemCount = snapshot.numChildren()
          const currentDers = findCurrentData(this.$store.getters.dersler, this.$route.params.id)
          this.$emit('baslikchange', currentDers.isim + ' / Detaylı Anlatım')
          this.$store.dispatch('setLoading', false)
        }
      })
    }
  },
  computed: {
    content () {
      if (this.search && this.search !== '') {
        return this.searchContent(this.contents, this.search, 'baslik')
      } else {
        return this.findContent(this.contents, this.page)
      }
    },
    findUrl () {
      const index = this.slugs.findIndex(s => s.id === this.$route.params.id)
      return this.slugs[index].slug
    }
  },
  created () {
    this.getData()
  },
  watch: {
    $route: function (_new, old) {
      if (_new.params.id !== old.params.id) {
        this.tableName = 'detaylianlatim/' + _new.params.id
        this.getData()
      }
      if (_new.params.page !== old.params.page) {
        this.workContent()
      }
    },
    sort: function () {
      this.workContent()
    },
    search: function () {
      if (this.search && this.search !== '') {
        this.pageShow = false
      } else {
        this.pageShow = true
      }
      this.workContent()
    }
  }

}
</script>
